//'La contraseña no cumple con los requisitos mínimos | ["Al menos 8 caracteres", "Una minúscula", "Una mayúscula", "Un número", "Un símbolo"]',
export const PASSWORD_VALIDATION =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
